import React, { useState } from "react";

import "../assets/css/unauthorized.css"
function Unauthorized() {
   

    return (
        <div className="Econtainer">
            <h1>403</h1>
            <p>access not granted based on your role</p>

        </div>


    )
}


export default Unauthorized;
